<script>
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import {mapGetters} from 'vuex';
import TrekLoading from '@/components/TrekLoading';
import {PdlCallout} from '@pedal/pdl-callout';
import TrekButton from '@/components/TrekButton';
import CartSummary from '@/components/cart/CartSummary';
import Tabs from '@/components/tabs/Tabs';
import TabPane from '@/components/tabs/TabPane';
import Collapse from '@/components/Collapse';
import Warehouse from '@/components/containers/checkout/Warehouse';
import ElDialog from '@/components/Dialog';

export default {
  components: {TrekLoading, PdlCallout, TrekButton, CartSummary, Tabs, TabPane, Collapse, Warehouse, ElDialog},

  props: {
    textBikes: {
      type: String,
      default: 'Bikes',
    },
    textAccessories: {
      type: String,
      default: 'Accessories',
    },
  },

  data() {
    return {
      cartData: {
        bikes: {
          warehouses: [],
        },
        parts: {
          warehouses: [],
        },
        cartSummary: {},
      },
      calculatedFreight: {
        bikes: false,
        parts: false,
      },
      loading: true,
      types: ['bikes', 'parts'],
      selectedTabName: '',
      accessoriesTabChecked: false,
      dialogVisible: false,
      targetUrl: '',
    };
  },

  computed: {
    bikes() {
      return this.cartData.bikes;
    },

    parts() {
      return this.cartData.parts;
    },

    bikeWarehouseIds() {
      return this.getWarehouseIds('bikes');
    },

    partWarehouseIds() {
      return this.getWarehouseIds('parts');
    },

    tabSelected: {
      get() {
        return this.selectedTabName || (!isEmpty(this.bikes) && this.bikes.totalAllocatedQty ? 'bikes' : 'parts');
      },
      set(name) {
        this.selectedTabName = name;
      },
    },

    isHoldOrder() {
      return (this.bikes && this.bikes.hold) || (this.parts && this.parts.hold);
    },

    isHoldBikesOnly() {
      return this.bikes && this.bikes.hold && (!this.parts || !this.parts.hold);
    },

    isHoldPartsOnly() {
      return (!this.bikes || !this.bikes.hold) && this.parts && this.parts.hold;
    },

    isHoldAllOrder() {
      return this.bikes && this.bikes.hold && this.parts && this.parts.hold;
    },

    bikesAndParts() {
      return {bikes: this.bikes, parts: this.parts};
    },

    showReviewLink() {
      return (
        this.isHoldAllOrder ||
        (this.isHoldBikesOnly && !this.hasAllocatedParts) ||
        (this.isHoldPartsOnly && !this.hasAllocatedBikes)
      );
    },

    hasAllocatedBikes() {
      return this.bikes && this.bikes.totalAllocatedQty;
    },

    hasAllocatedParts() {
      return this.parts && this.parts.totalAllocatedQty;
    },
    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  mounted() {
    this.loadCart();
  },

  provide() {
    return {
      container: this,
    };
  },

  methods: {
    cartSummaryLoaded() {
      this.enableSubmitListeners();
    },

    proceedToUrl() {
      window.location = this.targetUrl;
    },

    enableSubmitListeners() {
      $('.js-shipments-listener').click(
        $.proxy(function(event) {
          this.targetUrl = event.currentTarget.href;
          event.preventDefault();
          // The dialog should only appear if we're moving to order review stage (and not back to shipments)
          // and both tabs are present yet the second one is not visited yet
          if (
            this.targetUrl.includes('order-review') &&
            !this.accessoriesTabChecked &&
            this.bikes.totalAllocatedQty &&
            this.parts.totalAllocatedQty
          ) {
            this.dialogVisible = true;
          } else {
            this.proceedToUrl();
          }
        }, this)
      );
    },

    tabClicked(tab) {
      this.tabSelected = tab.name;
      if (tab.name == 'parts') this.accessoriesTabChecked = true;
    },

    updateCartSummary(cartSummary) {
      this.cartData.cartSummary = cartSummary;
    },

    changeGridTab(tab) {
      this.tabSelected = tab;
      if (tab == 'parts') this.accessoriesTabChecked = true;

      $('html, body').animate(
        {
          scrollTop: $(this.$refs.checkoutTabs.$el).offset().top - 150,
        },
        500
      );
    },

    getWarehouseIds(type) {
      if (!this[type] || !this[type].warehouses) return [];

      return this[type].warehouses.reduce((allWarehouseIds, warehouse) => {
        return [...allWarehouseIds, `${type}-${warehouse.id}`];
      }, []);
    },

    submitForm() {
      console.table(this.cartData.bikes);
    },

    getTabText(productType) {
      if (productType === 'bikes') return this.textBikes;
      if (productType === 'parts') return this.textAccessories;

      return '';
    },

    getFreightWarehouseData(warehouses) {
      if (isEmpty(warehouses)) return [];

      return map(warehouses, (warehouse) => {
        return {
          id: warehouse.id,
          isBackOrdered: false,
        };
      });
    },

    getFreightObject() {
      let data = {bikes: {}, parts: {}};

      data['isAllocatedItemsPage'] = true;
      if (this.cartData.bikes) {
        data.bikes['warehouses'] = this.getFreightWarehouseData(this.bikes.warehouses);
      }

      if (this.cartData.parts) {
        data.parts['warehouses'] = this.getFreightWarehouseData(this.parts.warehouses);
      }
      return data;
    },

    recalculateFreight(cartType) {
      axios
        .put('/cart/freight', this.getFreightObject())
        .then(() => {
          this.loadCart().finally(() => {
            this.calculatedFreight[cartType] = true;
          });
        })
        .catch((error) => console.log(error));
    },

    loadCart() {
      return axios
        .get('/checkout-b2b/api/allocated-items/items')
        .then(({data}) => {
          this.cartData = data;
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },

    navigateTo(url) {
      window.location.href = url;
    },
  },
};
</script>
